import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AgencyAdAccountsAndStores from './AgencyAdAccountsAndStores';

export const AgencyAdAccountsAndStoresWrapper = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // Create a history-like object for backwards compatibility
    const history = {
        push: navigate,
        replace: (path) => navigate(path, { replace: true }),
        // Add other history methods as needed
    };

    return <AgencyAdAccountsAndStores location={location} history={history} />;
}; 